import { ref } from 'vue';

export const appState = ref({
  isOffline: false,
});
